const editorHandles = {
  NODE_MENU: 'NODE_MENU',
  MORE_NODE_ACTIONS_MENU: 'MORE_NODE_ACTIONS_MENU'
};

export default editorHandles;